import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import bulbon from '../assets/bulbon.svg';
import bulboff from '../assets/bulboff.svg';
import chaletStore from '../state/chaletstore';


function MainControl() {
  const allOn = chaletStore((state) => state.allOn)
  const allOff = chaletStore((state) => state.allOff)
  const lights = chaletStore((state) => state.data.lights)
  const switchLight = chaletStore((state) => state.switchLight)


  return (
  <Container>
    <Row>
      <Col>General Switch:</Col>
      <Col><Button className="oncolor"  size="sm" 
      onClick={allOn}>Heating On</Button>
        </Col>
      <Col><Button className="offcolor"  size="sm" onClick={allOff}>Heating Off</Button></Col>
    </Row>
    {Object.values(lights).map((light) => (
      <Row key={light.id} className="pt-3">
        <Col>{light.name}:</Col>
        <Col>
          <Form>
            <Form.Check // prettier-ignore
              type="switch"
              className="light-switch"
              checked={light.switch}
              onChange={() => switchLight(light.id)}
            />
          </Form>
        </Col>
        {/* reported state of the device */}
        <Col>
          <img src={light.state ? bulbon : bulboff} width={24} height={24}
            alt={light.state ? 'on' : 'off'} title={light.state ? 'on' : 'off'} />
        </Col>
      </Row>
    ))}
    </Container>
  )
}

export default MainControl;
